import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@/shared/components/input/Checkbox';
import intlShape from '@/shared/utils/intlShape';
import { StateService } from '@/shared/services/StateService';
import { CanRead } from '@/shared/components/security';
import AuthService from '@/shared/services/AuthService';
import AbsenceCounterCell from './AbsenceCounterCell';
import messages from '../hrmMessages';

const HrmOverviewRow = ({
  intl,
  absences,
  data,
  handleSelect,
  onInitCounter,
  onOpenRegistrationOverview,
  onDeleteCounter,
  onOpenCounterDetails,
  stateService,
  inDays,
}) => {
  const currentUser = useMemo(() => AuthService.getUserId(), []);
  return (
    <tbody className="hover" key={data.employeeID} id={`RowID${data.employeeID}`}>
      <tr>
        <td>
          <Checkbox onClick={() => handleSelect(data)} value={data.selected} />
        </td>
        <td>
          {data.firstName} {data.lastName}
        </td>
        {absences?.map(x => {
          const counter = data?.counters ? data?.counters[x.id] : null;
          return (
            <td key={x.id} className="absence">
              <AbsenceCounterCell
                counter={counter}
                resourceId={x.id}
                employeeId={data.employeeID}
                userId={data.userID}
                intl={intl}
                onInitCounter={onInitCounter}
                onDeleteCounter={onDeleteCounter}
                onOpenRegistrationOverview={onOpenRegistrationOverview}
                onOpenCounterDetails={onOpenCounterDetails}
                inDays={inDays}
              />
            </td>
          );
        })}
        <td className="text-right">
          <CanRead on="Users">
            <a
              href={stateService.getStateUrl('employees.detail', { id: data.employeeID })}
              title={intl.formatMessage(messages.OpenEmployeeDetail)}
            >
              <i className="fa fa-external-link" />
            </a>
          </CanRead>
          <CanRead on={currentUser === data.userID ? 'RegistrationOwn' : 'RegistrationOthers'}>
            <a
              className="margin10L"
              onClick={() => onOpenRegistrationOverview({ userId: data.userID })}
              title={intl.formatMessage(messages.OpenRegistrationOverview)}
            >
              <i className="fa fa-th" />
            </a>
          </CanRead>
        </td>
      </tr>
    </tbody>
  );
};
HrmOverviewRow.propTypes = {
  intl: intlShape.isRequired,
  absences: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })).isRequired,
  data: PropTypes.shape({
    employeeID: PropTypes.string,
    userID: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    selected: PropTypes.bool,
    counters: PropTypes.shape({}),
  }).isRequired,
  handleSelect: PropTypes.func.isRequired,
  onInitCounter: PropTypes.func.isRequired,
  onOpenRegistrationOverview: PropTypes.func.isRequired,
  onDeleteCounter: PropTypes.func.isRequired,
  onOpenCounterDetails: PropTypes.func.isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
  inDays: PropTypes.bool,
};
HrmOverviewRow.defaultProps = {
  inDays: true,
};
export default HrmOverviewRow;
